export default "__VITE_ASSET__DSd54XIF__"